import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Logo } from './Logo';
import { useCity } from '../contexts/CityContext';

const NAV_ITEMS = [
  { path: '/mapa', label: 'Mapa', icon: MapIcon },
  { path: '/feed', label: 'Feed', icon: FeedIcon },
  { path: '/eventos', label: 'Eventos', icon: EventsIcon },
  { path: '/entregas', label: 'Entregas', icon: DeliveryIcon },
  { path: '/perfil', label: 'Perfil', icon: ProfileIcon },
];

function MapIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#0d5c3b' : '#9ca3af'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="1 6 1 22 8 18 16 22 21 18 21 2 16 6 8 2 1 6" />
      <line x1="8" y1="2" x2="8" y2="18" />
      <line x1="16" y1="6" x2="16" y2="22" />
    </svg>
  );
}

function FeedIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#0d5c3b' : '#9ca3af'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="9" y1="21" x2="9" y2="9" />
    </svg>
  );
}

function EventsIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#0d5c3b' : '#9ca3af'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

function DeliveryIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#0d5c3b' : '#9ca3af'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="3" width="15" height="13" rx="2" />
      <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
      <circle cx="5.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="18.5" r="2.5" />
    </svg>
  );
}

function ProfileIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={active ? '#0d5c3b' : '#9ca3af'} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

function useNavItems() {
  const location = useLocation();
  return NAV_ITEMS.map(item => ({
    ...item,
    active: location.pathname.startsWith(item.path),
  }));
}

// LE-RESP: barra de navegação inferior — exibida apenas no mobile (<768px).
export function BottomNav() {
  const navigate = useNavigate();
  const items = useNavItems();

  return (
    <nav className="nc-bottomnav" aria-label="Navegação principal">
      {items.map(item => (
        <button
          key={item.path}
          className="nc-bottomnav__item"
          data-active={item.active ? 'true' : 'false'}
          onClick={() => navigate(item.path)}
          aria-label={item.label}
          aria-current={item.active ? 'page' : undefined}
        >
          <item.icon active={item.active} />
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
}

// LE-RESP: sidebar à esquerda — exibida apenas no desktop (≥768px). Renderizada
// globalmente em App.js para que toda a navegação fique consistente.
export function Sidebar() {
  const navigate = useNavigate();
  const { selectedCity } = useCity();
  const items = useNavItems();

  return (
    <aside className="nc-sidebar" aria-label="Navegação principal">
      <div className="nc-sidebar__brand">
        <Logo size={32} />
      </div>
      <nav className="nc-sidebar__nav">
        {items.map(item => (
          <button
            key={item.path}
            className="nc-sidebar__item"
            data-active={item.active ? 'true' : 'false'}
            onClick={() => navigate(item.path)}
            aria-current={item.active ? 'page' : undefined}
          >
            <item.icon active={item.active} />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
      <div className="nc-sidebar__foot">
        {selectedCity ? `${selectedCity.name} / ${selectedCity.state}` : 'Nossa Cidade'}
      </div>
    </aside>
  );
}
